module.exports = __webpack_public_path__ + "img/V95.6bb6ce38.jpg";